<div class="card card--no-padding">
  <div class="subscription-detail-container__wrapper">
    <div class="subscription-detail-container__part">
      <div class="subscription-detail-container__header">
        <div class="subscription-detail-container__header-flex">
          <h3>{{ "Service.ActiveServices" | translate }}</h3>
          <div class="tags">
            @for (tag of tags(); track $index) {
              <div class="tag">{{ tag }}</div>
            }
          </div>
        </div>
        <div>
          <port-visualiser
            [subscription]="subscription()"
            [barsWillRoute]="false"
            (onSelected)="OnClickBar($event)"
            [highlightedSubscriptionId]="activeSubscriptionId()"
          >
          </port-visualiser>
        </div>
      </div>
      <div class="subscription-detail-container__list">
        @for (sub of services(); track sub.portSubscriptionInstanceId) {
          <service-row
            [service]="sub"
            [active]="sub.portSubscriptionInstanceId === activeSubscription()?.portSubscriptionInstanceId"
            (click)="setActiveSubscription(sub)"
          />
        }
      </div>
    </div>
    <div class="subscription-detail-container__part subscription-detail-container__part--right">
      @if (activeSubscription()) {
        <div class="subscription-detail-container__animate">
          <service-summary
            [service]="activeSubscription()"
            [showTraffic]="true"
            [vlanranges]="activeSubscriptionVlanranges()"
            [portId]="portId()"
          />
        </div>
      }
    </div>
  </div>
</div>
